import { Duration, MaintenanceScheduleAttributes } from '@/types'
import { CreateMaintenanceScheduleMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
  } = useForm<CreateMaintenanceScheduleMutation, MaintenanceScheduleAttributes, never, never>({
    defaultValues: {
      maintenanceTypeId: '',
      details: '',
      repeatMultiplier: 0,
      repeatPeriod: Duration.Day

    },
    mutation: CreateMutation,
    resultKey: 'createMaintenanceSchedule',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createMaintenanceSchedule?.maintenanceSchedule?.id) return

    navigate(`/settings/maintenance-schedules/${mutationData?.createMaintenanceSchedule?.maintenanceSchedule?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-3 gap-6">
        { formBuilder.buildField({ name: 'Maintenance type', field: 'maintenanceTypeId', type: 'maintenance-type' }) }
        { formBuilder.buildField({ name: 'Repeat multiplier', field: 'repeatMultiplier', type: 'integer' }) }
        { formBuilder.buildField({ name: 'Repeat period', field: 'repeatPeriod', type: 'multiplier-type' }) }
      </div>
      { formBuilder.buildField({ name: 'Details', field: 'details', type: 'text' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
